var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_tele_error",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_warning"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.252,3.147a2,2,0,0,1,3.5,0l6.6,11.882A2,2,0,0,1,16.6,18H3.4a2,2,0,0,1-1.748-2.971Z",
    transform: "translate(2 2)",
    fill: "#ff0700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleError);
export default __webpack_public_path__ + "static/media/ic_tele_error.3c2923cc63ac5f4686bf644f6731cba9.svg";
export { ForwardRef as ReactComponent };